import React from 'react';
import { Box } from '@mui/material';
import { ARIA_MESSAGE_TYPES } from '../ariaMessageTypes';
import AriaEventRecommendationCard from './AriaEventRecommendationCard';
import AriaFirstContactCalibrationCard from './AriaFirstContactCalibrationCard';
import AriaPeopleToMeetCards from './AriaPeopleToMeetCards';
import AriaPostEventSharePromptCard from './AriaPostEventSharePromptCard';

/**
 * Renders rich Aria message payloads from message.ariaPayload / ariaMessageType.
 * Cards are display-only in admin Handsoff (status UI only; no button actions).
 */
const AriaRichMessageContent = ({ message }) => {
  const type = message?.ariaMessageType;
  const payload = message?.ariaPayload;

  if (!type || !payload) return null;

  if (type === ARIA_MESSAGE_TYPES.EVENT_RECOMMANDATION) {
    return (
      <Box sx={{ mt: message?.text ? 1 : 0, width: '100%' }}>
        <AriaEventRecommendationCard event={payload} />
      </Box>
    );
  }

  if (type === ARIA_MESSAGE_TYPES.PEOPLE_TO_MEET) {
    if (!payload.candidates?.length) return null;
    return (
      <Box sx={{ mt: message?.text ? 1 : 0, width: '100%' }}>
        <AriaPeopleToMeetCards people={payload} />
      </Box>
    );
  }

  if (type === ARIA_MESSAGE_TYPES.POST_EVENT_SHARE_PROMPT) {
    return (
      <Box sx={{ mt: message?.text ? 1 : 0, width: '100%' }}>
        <AriaPostEventSharePromptCard prompt={payload} />
      </Box>
    );
  }

  if (type === ARIA_MESSAGE_TYPES.CALIBRATION) {
    if (!payload.suggestedAnswers?.length) return null;
    return (
      <Box sx={{ mt: message?.text ? 1 : 0, width: '100%' }}>
        <AriaFirstContactCalibrationCard calibration={payload} />
      </Box>
    );
  }

  return null;
};

export default AriaRichMessageContent;
